import { render, staticRenderFns } from "./CompareProduct.vue?vue&type=template&id=378a0098"
import script from "./CompareProduct.vue?vue&type=script&lang=js"
export * from "./CompareProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports